<template>
  <transition name="fade">
    <nav 
      v-if="category" 
      class="m-category-overview"
    >
      <h2 class="m-category-overview__top-level mb-6">
        {{ category.link.name }}
      </h2>
      <ul 
        v-if="hasVisibleChildren(category)" 
        class="m-category-overview__list"
      >
        <li 
          v-for="child in category.children.filter(x => !x.hideInNavigation)" 
          :key="child.id" 
          class="m-category-overview__item"
        >
          <div>
            <span 
              class="m-category-overview__label" 
              @click="toggle(child.id)"
            >
              {{ child.link.name }}
            </span>
            <ul 
              v-if="hasVisibleChildren(child)" 
              class="m-category-overview__sub-list"
              :class="{ '-active': active.includes(child.id) }"
            >
              <li 
                v-for="subChild in child.children.filter(x => !x.hideInNavigation)" 
                :key="subChild.id" 
                class="m-category-overview__item"
              >
                <base-link 
                  :link="subChild.link.url" 
                  class="m-category-overview__link"
                >
                  {{ subChild.link.name }}
                </base-link>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </nav>
  </transition>
</template>

<script>
import BaseLink from '@/components/atoms/BaseLink';

export default {
  name: 'CategoryOverview',
  components: {
    BaseLink,
  },
  props: {
    category: {
      type: Object,
      default: () => null,
    },
  },
  data () {
    return {
      active: []
    }
  },
  mounted () {
    this.active = this.$store.getters['navigation/getActivePath'];
  },
  methods: {
    hasVisibleChildren (item) {
      return item.hasChildren && item.children.filter(x => !x.hideInNavigation).length > 0;
    },
    toggle (id) {
      if (this.active.includes(id)) {
        this.active = this.active.filter(x => x !== id);
      } else {
        this.active.push(id);
      }
    },
  },
}
</script>
